<template>
  <div class="search-button-container">
    <!-- 筛选条件 -->
    <div class="filter-container">
      <div class="filter-group">
        <span class="filter-title">主题：</span>
        <div class="filter-button">
          <button 
            v-for="theme in themes" 
            :key="theme" 
            :class="{ active: selectedTheme === theme }"
            @click="selectFilter('theme', theme)"
          >
            {{ theme }}
          </button>
        </div>
      </div>

      <div class="filter-group">
        <span class="filter-title">价格：</span>
        <button 
          v-for="price in prices" 
          :key="price" 
          :class="{ active: selectedPrice === price }"
          @click="selectFilter('price', price)"
        >
          {{ price }}
        </button>
      </div>

      <div class="filter-group">
        <span class="filter-title">页数：</span>
        <div class="filter-button">
          <button 
            v-for="page in pages" 
            :key="page" 
            :class="{ active: selectedPage === page }"
            @click="selectFilter('page', page)"
          >
            {{ page }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { advancedSearch } from '@/api/product';  // 引入 API

export default {
  name: 'SearchButton',
  props: {
    pageSize: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      selectedTheme: '全部', // 默认选中的主题
      selectedPrice: '全部', // 默认选中的价格
      selectedPage: '全部', // 默认选中的页数
      themes: ['全部', '旅游家乡', '动漫', '个人介绍', '企业', '可爱', '电商购物', '传统文化', '人物明星', '电影音乐', '美食', '体育运动', '正能量'], // 主题列表
      prices: ['全部', '10', '15', '20', '25', '30', '40', '50', '60'], // 价格区间
      pages: ['全部', '1', '2-4', '5', '6-10', '11-15', '16-25'] // 页数区间
    };
  },

  methods: {
    // 选择筛选条件
    selectFilter(type, value) {
      if (type === 'theme') this.selectedTheme = value;
      if (type === 'price') this.selectedPrice = value;
      if (type === 'page') this.selectedPage = value;
      // 触发事件通知父组件重置 currentPage 为 1
    this.$emit('update-current-page', 1); 
      // 触发搜索
      this.$nextTick(() => {
        this.triggerSearch();
    });
    },

    // 触发搜索
    async triggerSearch() {
      const filters = {
        theme: this.selectedTheme,
        price: this.selectedPrice,
        page: this.selectedPage,
        pageSize: this.pageSize,  // 使用最新的 props
        currentPage: this.currentPage // 使用最新的 props
      };

      // console.log("filters:", filters); // 打印出最新的 filters
      try {
        const response = await advancedSearch(filters); // 调用 API，数据包裹在 filters 键下
        // 检查 response 的结构
        if (response && response.status === 200 && response.result) {
          // console.log('搜索结果：', response);
          this.$emit('search-success', response); // 将搜索结果传递给父组件
        } else {
          throw new Error('Unexpected response structure');
        }
      } catch (error) {
        console.error('搜索失败：', error);
        this.$emit('search-error', error); // 错误事件
      }
    }
  }
};
</script>

<style scoped>
.search-button-container {
  margin: 2vw;
  padding: 2vw;
  border: 1px solid #ccc;
  border-radius: 1vw;
  background-color: #f9f9f9;
}

.filter-container {
  margin-bottom: 2vw;
}

.filter-button {
  display: flex;
  flex-wrap: wrap;
  flex: 1;
}

.filter-group {
  margin-bottom: 1vw;
  display: flex;
  margin-top: 1vw;
}

.filter-title {
  margin-right: 1vw;
  font-size: 3.4vw;
  width: 12vw;
  padding-top: 10px;
}

.filter-group button {
  margin: 0.2vw 0;
  margin-right: 0.9vw;
  padding: 0.5vw 1vw;
  font-size: 3.4vw;
  border: 1px solid #ccc;
  border-radius: 0.5vw;
  background-color: white;
  cursor: pointer;
  min-width: 5.5vw;
}

.filter-group button.active {
  background-color: #F55654;
  color: white;
  border-color: #F55654;
}

.filter-group button:hover {
  background-color: #f7322f;
  color: white;
}
</style>
